export const AUTH_COOKIES = ['slt', 'slid', 'slrf'];
export const LOGOUT_URL = {
  dev: 'https://accounts.realestate.com.au/logout?client_id=15uto5o3sbdoijfpl744gbhu0d&logout_uri=https://api.smartline-dev.realestate.com.au/logout/callback',
  prod: 'https://accounts.realestate.com.au/logout?client_id=q4a431dou10hj4c2o99t8p73b&logout_uri=https://api.launchpad.smartline.com.au/logout/callback',
};
